import { HistoryRecord } from '../types';

const STORAGE_KEY = 'soggi_invoice_history';
const SETTINGS_KEY = 'soggi_invoice_settings';
const DOC_COUNTER_KEY = 'soggi_doc_counter';

// 발급 내역 불러오기
export function loadHistory(): HistoryRecord[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

// 발급 내역 저장
export function saveHistory(records: HistoryRecord[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

// 단건 추가
export function addRecord(record: HistoryRecord): void {
  const records = loadHistory();
  // 중복 ID 방지
  const filtered = records.filter(r => r.id !== record.id);
  filtered.unshift(record);
  saveHistory(filtered);
}

// 단건 수정
export function updateRecord(record: HistoryRecord): void {
  const records = loadHistory();
  const idx = records.findIndex(r => r.id === record.id);
  if (idx >= 0) {
    records[idx] = record;
    saveHistory(records);
  }
}

// 단건 삭제
export function deleteRecord(id: string): void {
  const records = loadHistory();
  saveHistory(records.filter(r => r.id !== id));
}

// 설정 불러오기
export function loadSettings(): any {
  try {
    const data = localStorage.getItem(SETTINGS_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

// 설정 저장
export function saveSettings(settings: any): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}

// 문서 번호 생성 (날짜별 순번)
export function generateDocNo(type: 'D' | 'R', dateStr: string): string {
  const dateKey = dateStr.replace(/-/g, '');
  const counterKey = `${DOC_COUNTER_KEY}_${type}_${dateKey}`;

  let current = 0;
  try {
    const stored = localStorage.getItem(counterKey);
    current = stored ? parseInt(stored, 10) : 0;
  } catch {}

  // 기존 내역에서 같은 날짜의 최대 번호 확인
  const records = loadHistory();
  const prefix = `${dateKey}-${type}`;
  records.forEach(r => {
    const no = type === 'D' ? r.quoteNo : r.receiptNo;
    if (no && no.startsWith(prefix)) {
      const num = parseInt(no.replace(prefix, ''), 10);
      if (!isNaN(num) && num > current) {
        current = num;
      }
    }
  });

  current += 1;
  localStorage.setItem(counterKey, String(current));
  return `${dateKey}-${type}${String(current).padStart(3, '0')}`;
}

// 문서 번호 중복 체크
export function isDocNoDuplicate(no: string, type: 'quote' | 'receipt', excludeId?: string): boolean {
  const records = loadHistory();
  return records.some(r => {
    if (excludeId && r.id === excludeId) return false;
    return type === 'quote' ? r.quoteNo === no : r.receiptNo === no;
  });
}

// JSON 백업 다운로드
export function downloadBackup(): void {
  const records = loadHistory();
  const json = JSON.stringify(records, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `soggi_invoice_backup_${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

// JSON 백업 불러오기
export function importBackup(json: string): boolean {
  try {
    const data = JSON.parse(json);
    if (Array.isArray(data)) {
      saveHistory(data);
      return true;
    }
    return false;
  } catch {
    return false;
  }
}
